import api from 'Plugins/api'
import Address from '../entities/address'

class AddressInteractor {
  /**
   * 获取常用地址列表
   */
  static async getAddressList() {
    try {
      const { data: addressList = [] } = await api['emp/vipEmpAddrGetList']()
      
      return {
        data: addressList.map(address => new Address(address))
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 根据地址Id获取地址信息
   */
  static async getAddressById(id) {
    try {
      const { data: addressList = [] } = await api['emp/vipEmpAddrGetList']({
        addrId: id
      })
      
      return {
        data: addressList[0] && new Address(addressList[0])
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 保存地址
   */
  static async saveAddress(payload) {
    try {
      payload.isDefault = payload.isDefault ? '1' : '0'

      await api['emp/vipEmpAddrEdit'](payload)
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 保存地址
   */
  static async deleteAddress(id) {
    try {
      await api['emp/vipEmpAddrDel']({ 
        empAddrId: id
      })
    } catch (error) {
      throw error
    }
  }
  
}

export default AddressInteractor